module.exports = __webpack_public_path__ + "img/ADC2CD_DFF7FA_C9E6F5_C1DBEC-256px.ab8949d8.png";